import { Theme, alpha } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { UiAlpha } from '../../styles/ui-alpha';

export const useStyles = makeStyles<Theme>()((theme) => ({
  toolbar: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    minWidth: 0,
  },
  toolbarTabs: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    alignItems: 'stretch',
  },
  readAllButton: {
    flexShrink: 0,
    textTransform: 'none',
  },
  readAllIconButton: {
    flexShrink: 0,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  card: {
    display: 'flex',
    alignItems: 'stretch',
    borderRadius: '10px',
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    overflow: 'hidden',
    position: 'relative',
  },
  cardClickable: {
    cursor: 'pointer',
  },
  accentBar: {
    width: 4,
    flexShrink: 0,
    backgroundColor: theme.palette.primary.main,
  },
  cardInner: {
    flex: 1,
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    minWidth: 0,
  },
  rowIconWrap: {
    ...theme.mixins.appIconTintSquare,
    width: 36,
    height: 36,
    padding: theme.spacing(0.75),
    marginTop: theme.spacing(0.25),
    flexShrink: 0,
    backgroundColor: alpha(theme.palette.primary.main, UiAlpha.Tint),
    color: theme.palette.primary.main,
  },
  rowIcon: {
    color: 'inherit',
  },
  rowText: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
  rowLine: {
    display: 'block',
    width: '100%',
  },
  rowTitle: {
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  rowTitleRead: {
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  rowSecondary: {
    color: theme.palette.text.secondary,
  },
  rowMeta: {
    color: theme.palette.text.secondary,
  },
  emptyStateText: {
    color: theme.palette.text.secondary,
  },
  unreadDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    flexShrink: 0,
    marginTop: theme.spacing(0.75),
  },
  sentinel: {
    height: 1,
    width: '100%',
  },
  skeletonIcon: {
    borderRadius: theme.spacing(0.5),
  },
  skeletonCardInnerCompact: {
    padding: theme.spacing(1),
  },
}));
